import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { CompanyProductTeam } from 'src/app/models/company_product_team.model';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { CompanyProductTeamCreditDialogComponent } from './company-product-team-credit-dialog/company-product-team-credit-dialog.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { CompanyProductPageIdentityComponent } from '../company-product-page-identity/company-product-page-identity.component';

@Component({
  selector: 'app-company-product-teams',
  templateUrl: './company-product-teams.component.html',
  styleUrls: ['./company-product-teams.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    CompanyProductPageIdentityComponent,
  ],
})
export class CompanyProductTeamsComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);
  private api = inject(ApiService);
  permissions = inject(PermissionsService);
  private dialog = inject(MatDialog);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  displayedColumns: string[] = ['name', 'users', 'actions'];
  dataSource: MatTableDataSource<CompanyProductTeam> = new MatTableDataSource();

  private company_product_id: string = null as any;

  ngOnInit(): void {
    this.initCompanyProductIdParam();
    this.fetchTeams();
  }

  add() {
    this.openCreditDialog();
  }

  edit(pt: CompanyProductTeam) {
    this.openCreditDialog(pt);
  }

  delete(pt: CompanyProductTeam) {
    this.api.deleteCompanyProductTeam(pt.id.toString()).subscribe(data => {
      this.fetchTeams();
    });
  }

  private initCompanyProductIdParam() {
    this.company_product_id = this.activatedRoute.snapshot.parent?.parent?.paramMap.get('id') as string;
  }

  private fetchTeams() {
    this.api.getCompanyProductCompanyProductTeams(this.company_product_id, { with: 'users' }).subscribe(data => {
      this.dataSource.data = data;
    });
  }

  private openCreditDialog(pt: CompanyProductTeam | undefined = undefined) {
    const dialogRef = this.dialog.open(CompanyProductTeamCreditDialogComponent, {
      width: '600px',
      data: {
        company_product_team: pt ?? { company_product_id: this.company_product_id },
      },
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data != null) {
        this.fetchTeams();
      }
    });
  }
}
